import Signin from "@/components/signin/App";
import { withProvider, getStaticProps } from "@/context/with-provider";
import AccountPages from "@/infrastructure/account/AccountPages";
import { useIsLogin } from "@/openbaas";
import React from "react";

function Account() {
  const { isLogin } = useIsLogin();
  return (
    <div>
      {isLogin ? (
        <div className="py-6">
          <h1 className="text-2xl font-semibold text-center mb-8">
            Configuraciones
          </h1>
          <AccountPages />
        </div>
      ) : (
        <>
          <div className="w-11/12 max-w-md mx-auto">
            <Signin />
          </div>
        </>
      )}
    </div>
  );
}

export { getStaticProps };

export default withProvider(Account);
